import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/** Legacy ?lang=ar links are permanently replaced by the /ar/... path. */
const params = new URLSearchParams(window.location.search);
if (params.get("lang") === "ar" && !window.location.pathname.startsWith("/ar")) {
  params.delete("lang");
  const query = params.toString();
  const path = window.location.pathname === "/" ? "" : window.location.pathname;
  window.location.replace(`/ar${path}${query ? `?${query}` : ""}${window.location.hash}`);
} else {
  if (params.get("lang") === "ar") {
    params.delete("lang");
    const query = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (query ? `?${query}` : ""));
  }
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
